<script setup lang="ts">
import { storeToRefs } from 'pinia';
import type { MachineType } from '../../types/Order';
import { useOrderStore } from '../../stores/orderForm';
import { useOrderFormDialog } from './useOrderFormDialog';

const { orderDialogOptions, isOrderOpen, toggleOrderDialog } = useOrderFormDialog();

function onClose(refetch?: boolean) {
  toggleOrderDialog(false);
  if (refetch) {
    orderDialogOptions.value.onRefetch();
  }
}

const store = useOrderStore();
const { machineType, isPreviewMode } = storeToRefs(store);
function onMachineTypeChange(type: MachineType) {
  store.setMachineType(type);
}
</script>

<template>
  <Dialog
    :visible="isOrderOpen"
    value
    modal
    :draggable="false"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    @update:visible="toggleOrderDialog"
  >
    <template #header>
      <div class="flex flex-wrap items-center gap-4">
        <h2 class="p-dialog-title">
          {{ $t('orderForm.title') }}
        </h2>

        <div v-if="isPreviewMode === false" class="flex items-center gap-2">
          <Button
            size="small"
            :severity="machineType === 'milling' ? 'primary' : 'secondary'"
            :outlined="machineType !== 'milling'"
            @click="onMachineTypeChange('milling')"
          >
            {{ $t('orders.orderMilling') }}
          </Button>
          <Button
            size="small"
            :severity="machineType === '3d' ? 'primary' : 'secondary'"
            :outlined="machineType !== '3d'"
            @click="onMachineTypeChange('3d')"
          >
            {{ $t('orders.order3D') }}
          </Button>
          <Button
            size="small"
            :severity="machineType === 'models' ? 'primary' : 'secondary'"
            :outlined="machineType !== 'models'"
            @click="onMachineTypeChange('models')"
          >
            {{ $t('orders.orderModels') }}
          </Button>
        </div>
      </div>
    </template>
    <OrderForm @close="onClose" @delete="orderDialogOptions.onDelete" />
  </Dialog>
</template>
